<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MZ75HW/tc-custom/9781399094320.jpg?1718106504026" alt="This image is the cover for the book Pirate Captain Ned Low"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pirate Captain Ned Low
      </h1>
      <p class="bookDescription body article font2">
        <p>Edward ‘Ned’ Low’s career in piracy began with a single gunshot. While working on a logging ship in the Bay of Honduras the quick-tempered Ned was provoked by the ship’s captain. He responded by grabbing a musket and inciting a mutiny. Then the London-born sailor and a dozen of his crewmates held a council, stitched a black flag and voted to make war against the whole world preying on ships from any nation, flying any flag. Low’s name became synonymous with brutality and torture during the 1720s as he cut a swathe of destruction from the shores of Nova Scotia to the Azores, the coast of Africa and throughout the Caribbean. Ned Low’s life was one of failed redemption: a thief from childhood who briefly rose in the world after moving to America, only to fall again lower and harder than before. He was feared even by his own crew, and during his life on the wrong side of the law he became infamous for his extreme violence, fatalistic behaviour, and became perhaps one of the best examples of why pirates were classed in Admiralty Law as hostis humani generis: the common enemies of all mankind.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicky Nielsen
      </h2>
      
      <p class="authorDescription body article">Dr Nicky Nielsen obtained a BA in Egyptian Archaeology before progressing to his Masters and PhD in Egyptology at Liverpool University. He is now a Lecturer in Egyptology at the University of Manchester, as well as Honorary Fellow at the University of Liverpool and Field Director of the Tell Nabasha archaeological excavation in northeastern Egypt. He has published a number of academic papers as well as articles in popular magazines in the UK, USA and his native Denmark, on topics spanning Egyptology, Roman history, British naval history and Viking culture.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d835f7e